'use client'

import { Autocomplete, TextField } from '@mui/material'
import { Controller } from 'react-hook-form'

// Types
import type { AutoCompleteFieldProps } from '@/types/components/molecules/inputs/autocomplete'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

const AutocompleteFieldMolecule = (props: AutoCompleteFieldProps) => {
	// Props
	const { lng, control, name, options, placeholder, required } = props

	// Variables
	const { t } = useTranslation(lng)

	return (
		<Controller
			control={control}
			name={name}
			rules={{ required }}
			render={({ field: { onChange, value, ref } }) => (
				<Autocomplete
					value={value || null}
					options={options}
					getOptionKey={option => option.value}
					getOptionLabel={option => t(typeof option === 'string' ? option : (option.name ?? option.title ?? option.label))}
					isOptionEqualToValue={(option, value) => (typeof value === 'object' ? option.value === value.value : option.value === value)}
					clearOnEscape={true}
					fullWidth
					renderInput={params => (
						<TextField
							{...params}
							inputRef={ref}
							value={value?.label || ''}
							placeholder={placeholder && t(placeholder)}
							required={required}
							fullWidth
							onChange={event => onChange(event.target.value)}
						/>
					)}
					onChange={(_, newValue) => onChange(newValue)}
				/>
			)}
		/>
	)
}

export default AutocompleteFieldMolecule
